import { render, staticRenderFns } from "./FakeSearchResult.vue?vue&type=template&id=32c8f08c&"
import script from "./FakeSearchResult.vue?vue&type=script&lang=ts&"
export * from "./FakeSearchResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports